import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"acknowledgement"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.contentElement.introduction)}}),_c(VCheckbox,{attrs:{"label":_vm.contentElement.acknowledgement,"hide-details":""},on:{"change":_vm.onSelectCheckbox}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }